// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1749":"03cb9ce8","3807":"cb870325","6533":"47d04136"}[chunkId] + ".chunk.css";
};